export interface DffSideTitel {
    sideTitel: string;
}
